export default __webpack_public_path__ + "static/ayu-922ddf3d128637e3e3ba3204a2b259b4.png";